var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9Z",
    fill: "white",
    stroke: "#FF8127",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40196 10.2312H9.59822C9.75978 10.2312 9.89041 10.1171 9.90072 9.96818L10.2067 5.54786C10.217 5.38625 10.0795 5.25 9.90416 5.25H8.09602C7.9207 5.25 7.7832 5.38625 7.79351 5.54786L8.09945 9.96818C8.10977 10.1171 8.24383 10.2312 8.40196 10.2312Z",
    fill: "#FF8127"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59743 11.0762H8.40117C8.23031 11.0762 8.0918 11.2039 8.0918 11.3614V12.4641C8.0918 12.6216 8.23031 12.7492 8.40117 12.7492H9.59743C9.7683 12.7492 9.90681 12.6216 9.90681 12.4641V11.3614C9.90681 11.2039 9.7683 11.0762 9.59743 11.0762Z",
    fill: "#FF8127"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMid);
export default __webpack_public_path__ + "static/media/mid.0bb99316f95d0240c8ea960b8ad199ff.svg";
export { ForwardRef as ReactComponent };